import { ModalController } from '@ionic/angular';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    modal: HTMLIonModalElement;

    constructor(private modalController: ModalController) { }

    async presentModal(component: any, param?: any) {
        this.modal = await this.modalController.create({
            component,
            componentProps: param
        });
        await this.modal.present();
        return this.modal;
    }
}

